// nb.vo.TimelineData
import TimelineDataSchema from '../schemas/TimelineDataSchema'
import TimelineSeriesSchema from '../schemas/TimelineSeriesSchema'

export function TimelineDataVo(initData = {}) {
  return TimelineDataSchema.validateSync(initData)
}

/**
 * @typedef {import ('../enums/MetricCategoryItem').default} MetricCategoryItem
 */

/**
 * @typedef {object} TimelineSeries
 * @property {number} topicId
 * @property {string} topicName
 * @property {import('../enums/MetricSeries').default} type
 * @property {boolean} isSupported
 * @property {boolean} isNegative
 * @property {boolean} isNoCount
 * @property {MetricCategoryItem} category
 * @property {boolean} isChild
 * @property {boolean} isDash
 * @property {number[]} data
 */

/**
 *
 * @param {*} initData
 * @returns {TimelineSeries}
 */
export function TimelineSeriesVo(initData = {}) {
  return TimelineSeriesSchema.validateSync(initData)
}
